<template>
  <div :id="id"></div>
</template>
<script>
import G2 from "@antv/g2";

export default {
  name: "barchart",
  props: ["chartData", "chartId"],
  data() {
    return {
      data: [],
      id: "",
      chart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      // console.log(newVal)
      function sortData(data) {
        for (let i = 0; i < data.length - 1; i++) {
          for (let j = 0; j < data.length - i - 1; j++) {
            if (data[j].value > data[j + 1].value) {
              let temp = data[j];
              data[j] = data[j + 1];
              data[j + 1] = temp;
            }
          }
        }
        console.log(data);
        return data;
      }
      this.data = sortData(this.data);
      this.chart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    function sortData(data) {
      for (let i = 0; i < data.length - 1; i++) {
        for (let j = 0; j < data.length - i - 1; j++) {
          if (data[j].value > data[j + 1].value) {
            let temp = data[j];
            data[j] = data[j + 1];
            data[j + 1] = temp;
          }
        }
      }
      return data;
    }
    this.data = sortData(this.data);
    this.chart = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector("#" + this.id + "").clientHeight,
      width: document.querySelector("#" + this.id + "").clientWidth,
      padding: [0, 0, 0, 'auto']
    });
    this.chart.source(this.data, {
      value: {
        alias: '纠纷案件'
      }
    });
    this.chart.axis('name', {
      label: {
        textStyle: {
          fill: '#fff',
          fontSize: 12
        }
      },
      tickLine: {
        alignWithLabel: false,
        length: 0
      },
      line: {
        lineWidth: 0
      }
    });
    this.chart.axis('value', {
      label: null,
      title: {
        offset: 30,
        textStyle: {
          fontSize: 12,
          fontWeight: 300
        }
      }
    });
    this.chart.legend(false);
    this.chart.coord().transpose();
    this.chart.interval().position('name*value').color('#3fe8f6').size(11).opacity(1).label('value', {
      textStyle: {
        fill: '#fff'
      },
      offset: 10
    }).animate({
      enter: {
        animation: 'fadeIn', // 动画名称
        easing: 'easeQuadIn', // 动画缓动效果
        delay: 100, // 动画延迟执行时间
        duration: 3000 // 动画执行时间
      }
    });
    this.chart.render();
  }
};
</script>
<style lang="scss" scoped>
#rank-chart {
  width: calc(100% - 18px);
  height: 100%;
}
</style>
